import { Field, FieldContainer } from '../../base/Field';

export const InputContainer = FieldContainer;

export const InputField = Field;
